import { useMemo } from "react"

import { resolveAppCommand, type AppCommand } from "@/lib/appCommands"
import { useRegisterCommands } from "@/contexts/CommandRegistryContext"

export function usePageCommands(commands: AppCommand[], enabled = true) {
  const normalizedCommands = useMemo(
    () =>
      commands.map((command) => ({
        ...resolveAppCommand(command, "contextual"),
        available: command.available ?? true,
      })),
    [commands],
  )

  useRegisterCommands(normalizedCommands, enabled)
}
